"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapObject;
function mapObject(object, mapper) {
  return Object.keys(object).reduce(function (result, key) {
    result[key] = mapper(object[key], key);
    return result;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/radium/lib/map-object.js
// module id = 302
// module chunks = 0